import * as Yup from 'yup';
import { validateField, ValidationType } from './formValidation';

export const getPersonalInfoValidationSchema = (isEmailRequired = true) =>
    Yup.object({
        purpose: validateField(ValidationType.STRING),
        citizenship: validateField(ValidationType.MULTI_SELECT),
        email: validateField(ValidationType.EMAIL, isEmailRequired),
        firstname: validateField(ValidationType.STRING),
        lastname: validateField(ValidationType.STRING),
        phone_number: validateField(ValidationType.PHONE),
    });

export const personalInfoValidationSchema = getPersonalInfoValidationSchema();
